module.exports = function() {
  return new Worker(__webpack_public_path__ + "8066655c609c5e2a2b27.worker.js");
};